import { FormField } from './field';

export class SignatureField extends FormField {

    options: {
        width?: number,
        height?: number,
        penColor?: string,
        backgroundColor?: string
    }
    disableCache: boolean = false;
    saveToScreenAssetLibrary: boolean = false;

    constructor(options: {} = {}) {
        super(options);
        this.options = {};
        this.options.width = options['width'];
        this.options.height = options['height'];
        this.options.penColor = options['penColor'] || 'rgb(0, 0, 0)';
        this.options.backgroundColor = options['backgroundColor'] || 'rgb(255, 255, 255)';
        try {
            const data = JSON.parse(options['additionalInfo']);
            this.disableCache = data['disableCache'] || false;
            this.saveToScreenAssetLibrary = data['saveToScreenAssetLibrary'] || false;
        } catch (e) {}

    }
}
